import React from 'react';
import styled from 'styled-components/macro';
import { NavGlobal } from 'containers';

const Nav = () => (
  <Navigation>
    <NavGlobal />
  </Navigation>
);

const Navigation = styled.nav`
  height: 100vh;
  display: flex;
  flex-direction: row;
  z-index: ${props => props.theme.values.zIndex.l};
  top: 0;
  position: sticky;
  /* width */
  ::-webkit-scrollbar {
    width: 0;
  }
`;

export default Nav
